module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-brands-400.woff2?3a8109c4ac75662f83556aa4a3addc75";